import { apiURL } from '@yingbaba/api';
import equipment from './assets/equipment.webp';
import equipmentSmall from './assets/equipment-small.webp';
import event from './assets/event.webp';
import eventSmall from './assets/event-small.webp';
import hero from './assets/hero.webp';
import heroSmall from './assets/hero-small.webp';
import pet from './assets/pet.webp';
import petSmall from './assets/pet-small.webp';
import post from './assets/post.webp';
import postSmall from './assets/post-small.webp';
import product from './assets/product.webp';
import productSmall from './assets/product-small.webp';
import scene from './assets/scene.webp';
import sceneSmall from './assets/scene-small.webp';
import studio from './assets/studio.webp';
import studioSmall from './assets/studio-small.webp';
import talent from './assets/talent.webp';
import talentSmall from './assets/talent-small.webp';
import voice from './assets/voice.webp';
import voiceSmall from './assets/voice-small.webp';

export const imageAssets = {
  equipment,
  equipmentSmall,
  event,
  eventSmall,
  hero,
  heroSmall,
  pet,
  petSmall,
  post,
  postSmall,
  product,
  productSmall,
  scene,
  sceneSmall,
  studio,
  studioSmall,
  talent,
  talentSmall,
  voice,
  voiceSmall,
  // Stable identifiers already stored in marketplace records.
  actor: talent,
  actorSmall: talentSmall,
  editor: post,
  editorSmall: postSmall,
  mountain: scene,
  mountainSmall: sceneSmall,
} as const;

const legacyAssetMap = new Map<string, string>(
  Object.entries(imageAssets).map(([name, src]) => [
    `/assets/${name.replace(/Small$/, '-small')}.webp`,
    src,
  ]),
);

export function assetUrl(src?: string) {
  if (!src) return imageAssets.studioSmall;
  if (src.startsWith('/api/v1/')) return apiURL(src.slice(7));
  const assetPath = src.match(/^\/assets\/[^?#]+/)?.[0];
  if (!assetPath) return src;
  const mapped = legacyAssetMap.get(assetPath);
  return mapped ? mapped + src.slice(assetPath.length) : src;
}

const categoryImages: Record<string, string> = {
  品牌宣传片: studioSmall,
  产品广告: productSmall,
  短视频: heroSmall,
  纪录片: studioSmall,
  动画制作: postSmall,
  活动拍摄: eventSmall,
  后期制作: postSmall,
  场景: sceneSmall,
  模特演员: talentSmall,
  宠物: petSmall,
  文案策划: heroSmall,
  摄影师: studioSmall,
  导演: studioSmall,
  编导: heroSmall,
  美术指导: studioSmall,
  配音: voiceSmall,
  剪辑师: postSmall,
  器材: equipmentSmall,
};
const catalogImages: Record<string, string> = {
  demands: heroSmall,
  providers: studioSmall,
  resources: equipmentSmall,
  cases: studioSmall,
};

export function categoryCover(kind: string, category?: string) {
  return categoryImages[category || ''] || catalogImages[kind] || studioSmall;
}

export function marketplaceCover(kind: string, item: { cover?: string; category?: string }) {
  const src = item.cover?.trim();
  const path = src?.split(/[?#]/)[0];
  return !src || (path && legacyAssetMap.has(path))
    ? categoryCover(kind, item.category)
    : assetUrl(src);
}
